import { screeningExclusionText } from "../screeningCopy"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { Link } from "react-router-dom"
import { BookingBreadcrumbs } from "../Breadcrumbs"

type NotEligiblePageProps = {
  // The exclusion-message id the BFF passed (screening disqualification or the known-data gate);
  // resolved to copy via screeningExclusionText. Absent/"" falls through to the single default.
  exclusionMessageId?: string | null
  // Navigates to Carrot Academy's care options (host-provided). The design's "resources below" link.
  onExploreCareOptions?: () => void
}

const HEADING = "Let's find you the right kind of care"

export function NotEligiblePage({ exclusionMessageId }: NotEligiblePageProps): JSX.Element {
  const message = screeningExclusionText(exclusionMessageId ?? "")

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg),
        maxInlineSize: 640
      })}
    >
      <BookingBreadcrumbs />

      <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.md) })}>
        <Typography variant="h2" component="h1">
          {HEADING}
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(theme.tokens.spacing.xl)
          })}
        >
          <Typography variant="body1">{message}</Typography>
          <Button component={Link} to={"/messages"} variant="contained" color="secondary">
            Send a message
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
